import {OtpDashboardData} from '@/types/otp';
import {createSlice} from '@reduxjs/toolkit';

export interface OtpState {
  otpDashboardData: OtpDashboardData | null;
}

const initialState: OtpState = {
  otpDashboardData: null
};

const otpSlice = createSlice({
  name: 'otpSlice',
  initialState,
  reducers: {
    setOtpDashboardData: (state, action) => {
      state.otpDashboardData = action.payload;
    }
  }
});

export const {setOtpDashboardData} = otpSlice.actions;
export default otpSlice.reducer;
